// RNG determinístico (mulberry32). Todo sorteio do jogo passa por aqui, e o
// estado do gerador fica dentro do GameState para que a partida seja
// reproduzível a partir de seed + ações.

export function mulberry32Step(state: number): [value: number, next: number] {
  const next = (state + 0x6d2b79f5) | 0;
  let t = next;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  const value = ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  return [value, next];
}

export class Rng {
  state: number;
  draws = 0;

  constructor(seed: number) {
    this.state = seed | 0;
  }

  /** Número em [0, 1). */
  next(): number {
    const [value, next] = mulberry32Step(this.state);
    this.state = next;
    this.draws++;
    return value;
  }

  /** Inteiro em [0, n). */
  int(n: number): number {
    return Math.floor(this.next() * n);
  }

  /** Dado de `sides` faces: [1, sides]. */
  die(sides = 6): number {
    return this.int(sides) + 1;
  }

  dice(count: number, sides = 6): number[] {
    const out: number[] = [];
    for (let i = 0; i < count; i++) out.push(this.die(sides));
    return out;
  }

  pick<T>(items: readonly T[]): T {
    return items[this.int(items.length)];
  }

  /** Embaralha uma cópia (Fisher-Yates). */
  shuffle<T>(items: readonly T[]): T[] {
    const out = items.slice();
    for (let i = out.length - 1; i > 0; i--) {
      const j = this.int(i + 1);
      [out[i], out[j]] = [out[j], out[i]];
    }
    return out;
  }
}

/** Converte qualquer texto ou número numa seed de 32 bits. */
export function seedFrom(input: string | number): number {
  if (typeof input === 'number' && Number.isFinite(input)) return input | 0;
  const text = String(input);
  let h = 2166136261;
  for (let i = 0; i < text.length; i++) {
    h ^= text.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h | 0;
}
